// Utilities to map domain objects to display icons

export function wildlifeIcon(subcategory: string | undefined, wildlifeTypes: Record<string, { icon: string }>): string {
  if (!subcategory) return '🦌'
  return wildlifeTypes[subcategory]?.icon || '🦌'
}

export function assetIcon(type: string | undefined, subcategory: string | undefined, wildlifeTypes: Record<string, { icon: string }> = {}): string {
  switch (type) {
    case 'wild_animal':
      return wildlifeIcon(subcategory, wildlifeTypes)
    case 'livestock':
      return '🐄'
    case 'crop_field':
      return '🌾'
    case 'building':
      return '🏠'
    default:
      return '📦'
  }
}

export function taskIcon(): string {
  return '📋'
}

